import React from 'react';
import { PageBuilder } from '../components/global/PageBuilder';
import { SEO } from '../components/global/SEO';
import CrossSells from '../components/main/CrossSells';
import { types } from '../utils/crossSells';

export const ReplenishmentsPage = () => (
  <PageBuilder>
    <SEO title="Replenishments | Blueprint" />
    <div className="a-view cross-sells">
      <div className="container">
        <CrossSells type={types.REPLENISHMENTS} />
      </div>
    </div>
  </PageBuilder>
);

export default ReplenishmentsPage;
